import React from "react";
import { getAdditionalCareAsync, patchAdditionalCareAsync } from "../../../../app/patientSlice";
import ConfirmationModal from "../../../secondary/ConfirmationModal/ConfirmationModal";
import { MultiSelectSectionEditMode } from "./MultiSelectSectionEditMode";
import { MultiSelectSectionViewMode } from "./MultiSelectSectionViewMode";
import { useSectionForm } from "./hooks/useSectionForm";
import { SectionBanners } from "../../../secondary";

const CONFIRMATION_MESSAGE = "All progress in this section will be lost. Are you sure want to cancel?";

const dataSelector = (state) => state.patient.additionalCare;
const listSelector = (state) => state.patient.additionalCareListoptions;

const hasDataFn = (resp, dataKey) => Array.isArray(resp?.[dataKey]) && resp[dataKey].length > 0;

const makePayloadBuilder = (getListViewMenuData) => (_, base) => ({
  ...base,
  additionalCare: getListViewMenuData(),
});

const processSelection = (e = [], setData) => {
  setData(e.filter((item) => item?.key).map((item) => item.key));
};

export const AdditionalCare = ({ interventionId, formularyId, assessmentDetails }) => {
  const hook = useSectionForm({
    interventionId,
    formularyId,
    dataSelector,
    listSelector,
    fetchAction: getAdditionalCareAsync,
    patchAction: patchAdditionalCareAsync,
    optionType: "additionalcare",
    dataKey: "additionalCare",
    hasDataFn,
    buildPayload: makePayloadBuilder(() => hook.listViewMenuData),
    processSelection,
    callViewModeOnMount: true,
  });

  return (
    <div>
      {hook.confirmationModal && (
        <ConfirmationModal message={CONFIRMATION_MESSAGE} onConfirm={hook.yesConfirmationModalClick} onClose={hook.confirmationClose} />
      )}

      <SectionBanners />

      {hook.editable ? (
        <MultiSelectSectionEditMode
          label="Additional Care:"
          fieldId="additionalCare"
          assessmentDetails={assessmentDetails}
          setFormChangesConfirm={hook.setFormChangesConfirm}
          handleSubmit={hook.handleSubmit}
          doSubmit={hook.doSubmit}
          listResp={hook.listResp}
          sectionData={hook.sectionData}
          listViewRef={hook.listViewRef}
          register={hook.register}
          onSelectChange={hook.handleListViewMenuChange}
          onCancelClick={hook.handleCancelClick}
        />
      ) : (
        <MultiSelectSectionViewMode
          label="Additional Care:"
          sectionData={hook.sectionData}
          listResp={hook.listResp}
          assessmentDetails={assessmentDetails}
          onEdit={hook.editMode}
          hasPermission={hook.hasPermission}
        />
      )}
    </div>
  );
};
